import { render, staticRenderFns } from "./cDonutChart.vue?vue&type=template&id=58a34c44&scoped=true"
import script from "./cDonutChart.vue?vue&type=script&lang=js"
export * from "./cDonutChart.vue?vue&type=script&lang=js"
import style0 from "./cDonutChart.vue?vue&type=style&index=0&id=58a34c44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a34c44",
  null
  
)

export default component.exports